import BaseInputComponent from "basecomponents/BaseInputComponent";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { InputField, TextArea } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import {
  getClientProfile,
  updateClientProfile,
} from "../actions/profileActions";
import { showPopUp, showModal } from "../utils/domUtils";

import { IProfile } from "../interfaces/IClient";

class ProfileCard extends BaseInputComponent {
  state = {
    name: "",
    email: "",
    phone: "",
    address: "",
    user: "",
    code: "",
    errors: {},
  };

  componentDidMount() {
    // @ts-ignore
    this.props.getClientProfile((success) => {
      if (success) {
        this.configStateFromProps();
      }
    });
  }

  static getDerivedStateFromProps(nextProps) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    return newState.changed ? newState : null;
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.profile.loading === true;
  }

  configStateFromProps() {
    // @ts-ignore
    const profile: IProfile = this.props.profile.data;
    if (!profile) return;

    this.setState({
      name: profile.name,
      email: profile.email,
      phone: profile.phone || "",
      address: profile.address || "",
      user: profile.user || "",
      code: profile.code,
    });
  }

  onUpdateProfile = () => {
    const { name, phone, address, user } = this.state;
    // @ts-ignore
    this.props.updateClientProfile(
      {
        name,
        phone,
        address,
        user,
      },
      (success) => {
        if (Object.keys(this.state.errors).length > 0) return;
        const popup = {
          title: "Perfil actualizado correctamente!",
          message: "",
        };
        if (!success) {
          popup.title = "Ocurrio un evento inesperado";
          popup.message =
            "Sentimos que no fuera posible actualizar el perfil, por favor intenta en unos minutos";
        }
        showPopUp(popup.title, popup.message);
        if (success) {
          this.configStateFromProps();
        }
      }
    );
  };

  getForm = () => {
    const { name, email, phone, user, address, code, errors } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="form-row">
          <InputField
            id="name"
            label="Nombre"
            extraClass="col-6"
            value={name}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />

          <InputField
            id="code"
            label="Codigo"
            extraClass="col-6"
            value={code}
            disabled={true}
            onChange={this.onChangeDisabled}
          />
        </div>

        <div className="form-row">
          <InputField
            id="phone"
            label="Telefono"
            extraClass="col-6"
            value={phone}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />

          <InputField
            id="user"
            label="Usuario"
            extraClass="col-6"
            value={user}
            onChange={this.onChangeTextInput}
            disabled={loading}
            error={errors}
          />
        </div>

        <InputField
          id="email"
          label="Correo"
          type="email"
          value={email}
          disabled={true}
          onChange={this.onChangeDisabled}
        />

        <TextArea
          id="address"
          value={address}
          label="Direcci&oacute;n de envio (Opcional)"
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div className="card">
        <div className="card-header">
          <div className="card-title">Perfil</div>
        </div>
        <div className="card-body">{this.getForm()}</div>
        <div className="card-footer">
          <button
            className="btn btn-secondary"
            onClick={() => {
              // @ts-ignore
              showModal(this.props.idmodal_update_password);
            }}
          >
            Cambiar clave
          </button>
          <button
            className="btn btn-primary float-right"
            onClick={this.onUpdateProfile}
          >
            Actualizar
          </button>
        </div>
      </div>
    );
  }
}

// @ts-ignore
ProfileCard.propTypes = {
  idmodal_update_password: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getClientProfile: PropTypes.func.isRequired,
  updateClientProfile: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  profile: state.profile,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getClientProfile,
  updateClientProfile,
})(ProfileCard);
